<script>
  import {createRecord} from "../../modules/api-client";

  export let dragging = false;
  export let value;

  async function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  async function dropHandler(ev) {
    dragging = false;
    ev.preventDefault();

    const files = ev.dataTransfer.files;
    for (const file of files) {
      console.log(file.name, file.type);
      const fileCreated = await createRecord('files', {
        name: file.name,
        type: file.type,
        file: await getBase64(file)
      });
      value = fileCreated._id;
    }

    removeDragData(ev);
  }

  function dragOverHandler(ev) {
    ev.preventDefault();
  }

  function removeDragData(ev) {
    ev.dataTransfer.items?.clear();
  }

  let counter = 0;

  function dragEnterHandler() {
    dragging = true;
    counter++;
  }

  function dragLeaveHandler() {
    counter--;
    if (counter === 0) dragging = false;
  }
</script>

<div class="drop-zone-container" on:drop="{dropHandler}"
     on:dragenter={dragEnterHandler} on:dragleave={dragLeaveHandler}
     on:dragover={dragOverHandler}>
    <div class="drop-zone-content">
        <slot/>
    </div>
    <div class="overlay {dragging ? '' : 'd-none'}">+</div>
</div>

<style>
    .drop-zone-container {
        position: relative;
        display: block;
    }

    .drop-zone-content {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 0;
    }

    .overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 1;
        background: rgba(43, 82, 197, 0.2);
        z-index: 1;
        text-align: center;
        vertical-align: middle;
        line-height: 500;
    }
</style>